import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MerchantService } from '../_services/merchant.service';

@Injectable({
  providedIn: 'root'
})
export class RegistrationGuard  {
  private readonly router: Router = inject(Router);
  private readonly merchantService: MerchantService = inject(MerchantService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.merchantService.checkSession();
    if (!this.merchantService.accessAllowed) {
      return true;
    } else {
      this.router.navigate(['public/home'], {});
      return false;
    }
  }

}
